<ion-toolbar>
  <div class="toolbar-header">
    <ion-button (click)="dismissModal()" fill="none" color="secondary">
      <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
    </ion-button>
    <div class="right"></div>
  </div>
</ion-toolbar>
<ion-content class="ion-padding">
  <div class="qr-code" *ngIf="qrCodeInfo; else noQrCode">
    <app-qrcode [data]="qrCodeInfo" [width]="200"></app-qrcode>
  </div>
  <ng-template #noQrCode>
    <app-error-container icon="qr-code-outline"> </app-error-container>
  </ng-template>
</ion-content>
